import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading4 } from '../../../../Components/FormHeading';
import { useParams } from 'react-router-dom';

import NavPill from './NavPill';
import Certificates from './PostActivitiesTabs/Certificates/Certificates';
import FilesPostEventActivities from './PostActivitiesTabs/Files/FilesPostEventActivities';
import Summary from './PostActivitiesTabs/Summary/Summary';
import ImagesPostEventActivities from './PostActivitiesTabs/Photos/ImagesPostEventActivities';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { useMemo } from 'react';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

const fullNavs = [
  {
    id: 'postEventActivities.summary'
  },
  {
    id: 'postEventActivities.files'
  },
  {
    id: 'postEventActivities.images'
  },
  {
    id: 'postEventActivities.certificate'
  }
];

function PostEventActivities() {
  const { id } = useParams();

  const {
    event: { post_event_id }
  } = useSelector((state) => state.event);
  const user = useSelector((state) => state.user.user);
  const event = useSelector((state) => state.event.event);

  const [postEvent, setPostEvent] = useState({});
  const [activeNav, setActiveNav] = useState('postEventActivities.summary');
  const [navContents, setNavContents] = useState([
    {
      id: 'postEventActivities.summary'
    },
    {
      id: 'postEventActivities.certificate'
    }
  ]);

  const activeRole = user?.active_role;
  const eventCreatedById = event.created_by?.id;

  const handleActiveTab = (id) => {
    setActiveNav(id);
  };

  const CAN_EDIT = checkPermission(activeRole, 'update post event activity', {
    cdAdminId: user?.id,
    eventCreatedById: eventCreatedById
  });

  const { isCompleted, postEventId } = useMemo(() => {
    return {
      isCompleted: Boolean(postEvent?.is_completed),
      postEventId: post_event_id || postEvent?.id
    };
  }, [postEvent]);
  useEffect(() => {
    if (post_event_id) {
      fetchWrapper.get(`/event/post/${post_event_id}/`).then((res) => {
        setPostEvent(res);
      });
      setNavContents(fullNavs);
    }
  }, [post_event_id]);

  let content = null;

  const handlePostEventSummarySave = (newData) => {
    setPostEvent((prevState = {}) => ({ ...prevState, ...newData }));
    setNavContents(fullNavs);
  };

  switch (activeNav) {
    case 'postEventActivities.files':
      content = (
        <FilesPostEventActivities
          id={id}
          postEventId={postEventId}
          postEvent={postEvent}
          setPostEvent={setPostEvent}
          isCompleted={isCompleted}
          CAN_EDIT={CAN_EDIT}
        />
      );
      break;
    case 'postEventActivities.images':
      content = (
        <ImagesPostEventActivities
          id={id}
          postEventId={postEventId}
          postEvent={postEvent}
          setPostEvent={setPostEvent}
          isCompleted={isCompleted}
          CAN_EDIT={CAN_EDIT}
        />
      );
      break;
    case 'postEventActivities.summary':
      content = (
        <Summary
          id={id}
          postEventId={postEventId}
          postEvent={postEvent}
          handlePostEventSummarySave={handlePostEventSummarySave}
          isCompleted={isCompleted}
          CAN_EDIT={CAN_EDIT}
        />
      );
      break;
    case 'postEventActivities.certificate':
      content = <Certificates id={id} CAN_EDIT={CAN_EDIT} />;
      break;
    default:
      content = null;
  }

  return (
    <div className="card">
      <div className="card-header">
        <Heading4 className="text-primary">
          <FormattedMessage id="event.postEventActivity" />
        </Heading4>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-2 border-end">
            {navContents.map((item) => (
              <NavPill
                key={item.id}
                id={item.id}
                active={item.id === activeNav}
                onClick={handleActiveTab}
              />
            ))}
          </div>
          <div className="col-10">{content}</div>
        </div>
      </div>
    </div>
  );
}

export default PostEventActivities;
